export const handleTextAreaChange = (setFormState) => (e) => {
    setFormState({ text: e.target.value });
};

export const handleModalClose = (setFormState, onClose, handleResetButtonClick) => () => {
    setFormState({ text: '' });
    onClose();
    handleResetButtonClick();
};